export const REFRESH_SIDEBAR_MENU_ON_MOBILE = Symbol('REFRESH_SIDEBAR_MENU_ON_MOBILE');

export const SETTINGS_FOLDER_DRAG_TRANSFER_DATA = 'SETTINGS_FOLDER_DRAG_TRANSFER_DATA';

export enum FolderEditActionType {
  NEW = 'new',
  EDIT = 'edit'
}
